var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 88,
    viewBox: "0 0 184 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3231 2.76965C16.3231 4.29965 15.1691 5.53967 13.7453 5.53967C12.3214 5.53967 11.1675 4.29965 11.1675 2.76965C11.1675 1.23965 12.3214 -0.000244141 13.7453 -0.000244141C15.1691 -0.000244141 16.3231 1.23965 16.3231 2.76965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3805 2.76965C42.3805 4.29965 41.2265 5.53967 39.8026 5.53967C38.3788 5.53967 37.2249 4.29965 37.2249 2.76965C37.2249 1.23965 38.3788 -0.000244141 39.8026 -0.000244141C41.2265 -0.000244141 42.3805 1.23965 42.3805 2.76965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3375 69.7998L11.1768 52.3298V87.2698L39.3375 69.7998ZM35.1032 69.7998L13.2986 83.3298V56.2698L35.1032 69.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4974 69.7998L59.3367 52.3298V87.2698L87.4974 69.7998ZM83.2631 69.7998L61.4585 83.3298V56.2698L83.2631 69.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.657 69.7998L107.497 52.3298V87.2698L135.657 69.7998ZM131.423 69.7998L109.618 83.3298V56.2698L131.423 69.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.827 69.7998L155.666 52.3298V87.2698L183.827 69.7998ZM179.592 69.7998L157.788 83.3298V56.2698L179.592 69.7998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.8a2562a58f55c65eb7d74bc9cf5c159f.svg";
export { ForwardRef as ReactComponent };